import { parse } from 'content-disposition-header';
const getInitials = (name, extractChars) => {
    if (!name)
        return '';
    const size = name.length < extractChars ? name.length : extractChars;
    const initials = name.slice(0, size);
    return initials;
};
export const getUpperCaseInitials = (values, extractChars = 1) => {
    return values.reduce((initials, currentName) => initials.concat(getInitials(currentName, extractChars).toUpperCase()), '');
};
export const getFileNameFromContentDispositionHeader = (value) => {
    if (!value)
        return '';
    return parse(value).parameters.filename;
};
